import { PureComponent } from 'react';
import { noop } from 'lodash';

// COMPONENTS
import MaybeTranslation from 'components/MaybeTranslation';

// CONSTANTS
import { ACTIVE } from 'styles/commonClasses';

// STYLES
import { RadioContainer, RadioRound } from './RadioButtons.styles';

class RadioButton extends PureComponent {
  static defaultProps = {
    active: false,
    renderedValue: undefined,
    onClick: noop,
  };

  render() {
    return (
      // @ts-expect-error TS(2339): Property 'onClick' does not exist on type 'Readonl... Remove this comment to see the full error message
      <RadioContainer onClick={this.props.onClick}>
        <RadioRound
          // @ts-expect-error TS(2339): Property 'selected' does not exist on type 'Readon... Remove this comment to see the full error message
          selected={this.props.selected}
          data-testid="radio-button"
          // @ts-expect-error TS(2339): Property 'active' does not exist on type 'Readonly... Remove this comment to see the full error message
          className={this.props.active ? ACTIVE : undefined}
          // @ts-expect-error TS(2769): No overload matches this call.
          tabIndex="0"
        >
          <div />
        </RadioRound>
        {/* @ts-expect-error TS(2339): Property 'renderedValue' does not exist on type 'R... Remove this comment to see the full error message */}
        <MaybeTranslation renderedValue={this.props.renderedValue} />
      </RadioContainer>
    );
  }
}

export default RadioButton;
